package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2026_09_12_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We return to our heroes who have just saved a Roc from a Storm Giant’s dark ritual. A number of veteran soldiers ambushed the heroes during this encounter, and two have survived. The Roc attacked Bigglesworth even though the heroes intervened to save the creature.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes kill the remaining veteran soldiers. Caper ascends to the Roc’s level and tries to persuade it of the Heroes’ good intentions. While it’s uncertain if the Roc comprehended, it flies away to the west, leaving Bigglesworth sulking over his empty belly.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Goram takes the ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://www.dndbeyond.com/magic-items/4827-belt-of-frost-giant-strength") {
            org.jetbrains.compose.web.dom.Text("Belt of Frost Giant Strength")
        }
        org.jetbrains.compose.web.dom.Text(" from the fallen Giant while Caper adds the crossed Warhammer amulet/key to her thong. Bigglesworth pries a storm crystal from the altar and gives it to Annette.")
    }
}
